var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"main-content",attrs:{"id":"display-body"}},[_c('el-header',{staticClass:"header"},[_c('fire-header')],1),_c('el-container',{staticClass:"content"},[_c('el-aside',[_c('map-content'),_c('right-stat')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }